//@flow

export type PageLayoutType = 'HOME_PAGE';

export type PageLayoutSection<SECTION_TYPE> = {
  pageSectionType: SECTION_TYPE,
  enabled: boolean,
  sectionIdentifier?: string,
};

export type PageLayoutResponse<SECTION_TYPE> = {
  pageLayoutType: PageLayoutType,
  layout: PageLayoutSection<SECTION_TYPE>[],
  enabled: boolean,
};

export type PageLayoutRequest<SECTION_TYPE> = {
  pageLayoutType: PageLayoutType,
  layout: PageLayoutSection<SECTION_TYPE>[],
  enabled?: boolean,
};

export * from './home-layout';
